import SvgIcon from '@/components/SvgIcon'; // svg组件
import { createApp } from 'vue';

export function registerSvgIcon(app) {
  // 全局注册 SvgIcon 组件
  app.component('svg-icon', SvgIcon);

  // 加载所有的 SVG 文件
  const req = require.context('./svg', false, /\.svg$/);
  const requireAll = (requireContext) => requireContext.keys().map(requireContext);
  requireAll(req);
}
